<template>
<div class="chapter">
<div class="inner_page">
<h3 class="sub_head">THE PIE OF HAPPINESS</h3>
<p class="noindent"><a id="page_3"></a>Economists like to talk about the economy as a pie. A pie is a good way to think about the well-being—or, in the language of early social scientists, happiness—that an economy produces. It turns out that the pie of happiness is largest when the resources of society are distributed equally. Inequality makes the pie smaller.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12_Chapter_2.vue?97fd1d1c